module.exports = __webpack_public_path__ + "img/about-us-dark.31b232e4.svg";